import login from './login';
import SSOlogin from './SSOlogin';
import censusSSOlogin from './censusSSOlogin';
import selectClient from './selectClient';
import logout from './logout';
import updateUserAgreement from './updateUserAgreement';
import reInitState from './reInitState';
import sendPasswordRecoveryMail from './sendPasswordRecoveryMail';
import sendNotification from '../notifications/send';
import getFilters from '../filters/getFilters';

import combineActions from '../../utils/combineActions';

export default combineActions({
    login,
    SSOlogin,
    censusSSOlogin,
    selectClient,
    logout,
    updateUserAgreement,
    reInitState,
    sendPasswordRecoveryMail,
    sendNotification,
    getFilters,
});
